import React, { useEffect, useState } from 'react'
import Handler from '../../Helpers/Handler';
import { Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from 'reactstrap';
import moment from 'moment';
import { toast } from 'react-toastify';
import { saveAs } from 'file-saver';
import Pagination from '../../Helpers/Pagination';
import "boxicons/css/boxicons.min.css";
import { useDispatch, useSelector } from 'react-redux';
import { loadingFalse, loadingTrue } from '../../Reducer/loaderSlice';

const List = () => {
    const formatIST = (utcTime) => {
        if (!utcTime) return "-";
        const iso = utcTime.replace(" ", "T") + "Z";
        return new Date(iso).toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true
        });
    };

    const [data, setData] = useState([]);
    const [qr, setQr] = useState('');
    const [qrModal, setQrModal] = useState(false);
    const dispatch = useDispatch()
    const loading = useSelector((state) => state?.loading?.loading);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [search, setSearch] = useState('');

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text)
            .then(() => toast.success("Link copied"))
            .catch(() => toast.error("Copy failed"));
    };

    const getProducts = async () => {
        const response = await Handler({
            method: "get",
            url: `/qr/list.php?search=${search}&page=${page}&limit=${limit}`
        });

        if (response?.success) {
            setData(response?.data);
            setTotal(response?.total);
            setPage(response?.page);
        } else {
            toast.error(response?.message);
        }
    };

    const generate = async () => {
        if (!qr || qr.length < 1) {
            toast.error("QR Name Required");
            return;
        }
        dispatch(loadingTrue())
        const response = await Handler({
            method: "post",
            url: `/qr/generate.php`,
            data: { table_no: qr }
        });

        if (response?.success) {
            dispatch(loadingFalse())
            toast.success(response?.message);
            getProducts();
            setQr('');
            setQrModal(false);
        } else {
            dispatch(loadingFalse())
            toast.error(response?.message);
        }
    };

    const handleDownload = async (file, name) => {
        const downloadUrl = `https://bizcarto.in/demoadmin/api/qr/download.php?file=${file}`;
        try {
            const response = await fetch(downloadUrl);
            if (!response.ok) {
                toast.error("Download failed");
                return;
            }
            const blob = await response.blob();
            const fileName = `${name}.png`;
            saveAs(blob, fileName);
        } catch (error) {
            toast.error("Unable to download file");
            console.error("Download Error:", error);
        }
    };

    useEffect(() => { getProducts(); }, [page]);
    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            setPage(1);
            getProducts();
        }, 300);
        return () => clearTimeout(delayDebounce);
    }, [search]);

    return (
        <div className="dashboard-wrapper py-4">
            {/* Custom Responsive Styles */}
            <style>{`
                @media (max-width: 576px) {
                    .dashboard-header-flex {
                        flex-direction: column;
                        align-items: flex-start !important;
                        gap: 15px;
                    }
                    .header-actions {
                        width: 100%;
                    }
                    .searchbox {
                        width: 100% !important;
                    }
                    .btn-add {
                        width: 100%;
                        justify-content: center;
                    }
                    .dash-card {
                        padding: 15px !important;
                    }
                    .link-text {
                        max-width: 150px;
                        display: inline-block;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }
                .modern-table th {
                    white-space: nowrap;
                }
                .product-img {
                    width: 50px;
                    height: 50px;
                    object-fit: contain;
                }
            `}</style>

            <div className="container">

                {/* HEADER */}
                <div className="d-flex justify-content-between align-items-center mb-4 dashboard-header-flex">
                    <h5 className="section-heading mb-0">
                        <i className="bx bx-qr me-2 text-primary"></i> QR List
                    </h5>

                    <div className="d-flex gap-2 header-actions">
                        <Input
                            className="searchbox shadow-sm"
                            style={{ minWidth: '200px' }}
                            type="text"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder="Search QR..."
                        />
                        <Button color="primary" className="btn-add d-flex align-items-center shadow-sm" onClick={() => setQrModal(true)}>
                            <i className='bx bx-plus me-1'></i> Generate
                        </Button>
                    </div>
                </div>

                {/* TABLE CARD */}
                <div className="dash-card p-4 mb-4 bg-white shadow-sm rounded">
                    <div className="table-responsive">
                        <table className="table modern-table align-middle">
                            <thead className="table-light">
                                <tr>
                                    <th>#</th>
                                    <th>QR Code</th>
                                    <th>Slug Name</th>
                                    <th>QR Name</th>
                                    <th>Link</th>
                                    <th>Created At</th>
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {data.length > 0 ? (
                                    data.map((item, index) => (
                                        <tr key={item.qr_id}>
                                            <td>{(page - 1) * limit + index + 1}</td>

                                            <td>
                                                <img
                                                    src={`https://bizcarto.in/demoadmin/api/qr_images/${item.qr_slug}.png`}
                                                    alt={item.qr_slug}
                                                    className="product-img border rounded p-1"
                                                />
                                            </td>

                                            <td className="text-capitalize fw-bold">{item.qr_slug}</td>
                                            <td className="text-capitalize">{item.table_no}</td>

                                            <td className="text-lowercase">
                                                <div className="d-flex align-items-center gap-2">
                                                    <span
                                                        className="link-text text-primary"
                                                        style={{ cursor: "pointer", textDecoration: "underline" }}
                                                        onClick={() => copyToClipboard(`https://democustomer.bizcarto.in/login/${item.qr_slug}`)}
                                                    >
                                                        {`https://democustomer.bizcarto.in/login/${item.qr_slug}`}
                                                    </span>
                                                    <Button 
                                                        size="sm" 
                                                        color="light" 
                                                        className="p-1 border shadow-sm"
                                                        onClick={() => copyToClipboard(`https://democustomer.bizcarto.in/login/${item.qr_slug}`)}
                                                    >
                                                        <i className="bx bx-copy"></i>
                                                    </Button>
                                                </div>
                                            </td>

                                            <td style={{ fontSize: '13px' }}> {formatIST(item.created_at)}</td>

                                            <td className="text-center">
                                                <Button
                                                    size="sm"
                                                    color="dark"
                                                    className="rounded-pill px-3 shadow-sm d-inline-flex align-items-center"
                                                    onClick={() =>
                                                        handleDownload(`${item.qr_slug}.png`, item.qr_slug)
                                                    }
                                                >
                                                    <i className="bx bx-download me-1"></i> Download
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="text-center py-5 text-muted">
                                            No QR Codes Found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* PAGINATION */}
                    <div className="mt-4 d-flex justify-content-center">
                        <Pagination
                            page={page}
                            total={total}
                            limit={limit}
                            onPrev={() => page > 1 && setPage(page - 1)}
                            onNext={() => page < Math.ceil(total / limit) && setPage(page + 1)}
                        />
                    </div>
                </div>

            </div>

            {/* QR MODAL */}
            <Modal isOpen={qrModal} toggle={() => setQrModal(!qrModal)} centered size="sm">
                <ModalHeader className="border-bottom-0" toggle={() => setQrModal(!qrModal)}>
                    Generate New QR
                </ModalHeader>

                <ModalBody className="py-0">
                    <FormGroup>
                        <Label className="small fw-bold">Table / QR Reference Name</Label>
                        <Input
                            type="text"
                            placeholder="e.g. Table 1 or VIP Room"
                            value={qr}
                            className="py-2"
                            onChange={(e) => setQr(e.target.value)}
                        />
                    </FormGroup>
                </ModalBody>

                <ModalFooter className="border-top-0 gap-2">
                    <Button color="light" className="px-4" onClick={() => setQrModal(false)}>Cancel</Button>
                    <Button 
                        color="primary" 
                        disabled={loading} 
                        onClick={generate} 
                        className="px-4 d-flex align-items-center gap-2"
                    >
                        {loading && <Spinner size="sm" color="light" />}
                        Generate
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}

export default List;